import React from 'react';
import { Form, Input, Row, Col, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const CheckDeviceConfigModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = (values) => {
    console.log('Received values:', values);
    props.action(values);
  };

  return (
    <Modal
      title="Check Device Configuration"
      open={props.visible}
      onOk={() => form.submit()}
      okText={t("Send")}
      onCancel={props.close}
      width={700}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={props.selectedDevice}
        layout="vertical"
      >
        <p>
          {t("DevicePage.table.id")}:
          <span style={{ fontWeight: 'bold' }}>
            {props.selectedDevice ? props.selectedDevice.Id : ''}
          </span>
        </p>

        <p>
          {t("DevicePage.deviceModal.lastModified")}:
          <span style={{ fontWeight: 'bold' }}>
            {props.selectedDevice
              ? props.selectedDevice["LAST DATA"]
              : ''}
          </span>
        </p>

        <Row gutter={16}>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.macAddress")}
              name="MAC"
              rules={[
                {
                  required: true,
                  message: t("DevicePage.deviceModal.macAddressRequired")
                }
              ]}
            >
              <Input readOnly />
            </Form.Item>
          </Col>

          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.name")}
              name="NAME"
              rules={[
                {
                  required: true,
                  message: t("DevicePage.deviceModal.nameRequired")
                }
              ]}
            >
              <Input readOnly />
            </Form.Item>
          </Col>
        </Row>

        {/* Config Messages */}
        <div style={{ marginTop: 20 }}>
          <h6>Retrieved Messages</h6>

          <div
            style={{
              background: '#f5f5f5',
              padding: 12,
              borderRadius: 8,
              maxHeight: 300,
              overflowY: 'auto'
            }}
          >
            {props.data && props.data.length > 0 ? (
              props.data.map((item, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: 8,
                    padding: 8,
                    background: 'white',
                    borderRadius: 6,
                    border: '1px solid #ddd'
                  }}
                >
                  {item}
                </div>
              ))
            ) : (
              <p>No data</p>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default CheckDeviceConfigModal;